module.exports = __webpack_public_path__ + "assets/img/carousel_car.91c7385c.jpg";